import { type ReactNode } from "react";

import Spinner from "components/Spinner";

interface ContentProps {
  isLoading: boolean;
  children?: ReactNode;
  className?: string;
}

export default function Content({ isLoading, children, className = "" }: ContentProps) {
  if (isLoading) {
    return (
      <div className={`flex items-center justify-center absolute top-0 left-0 right-0 bottom-0 ${className}`}>
        <Spinner />
      </div>
    );
  }

  return <>{children}</>;
}
